import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import webDesign from "../../assets/web-design.png";
import coding from "../../assets/coding.png";
import applcation from "../../assets/application.png";
import Card from "@mui/material/Card";
import { v4 as uuidv4 } from "uuid";
import Paper from "@mui/material/Paper";
import user from "../../assets/user.png";
import feedback from "../../assets/feedback.gif";
const Testimonials = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 2, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  let featureList = [
    // {
    //   id: uuidv4(),
    //   title: " Bramhanand Patil",
    //   company: "SaiSantha",
    //   image: webDesign,
    //   description:
    //     "Working with Flint Infotech was a game-changer for us. Their dynamic web app solution significantly boosted our online presence, and the team's dedication to perfection was truly commendable.",
    // },
    // {
    //   id: uuidv4(),
    //   title: " Narsu Patil",
    //   company:
    //     "E.B.GADKARI HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL, GADHINGLAJ",
    //   image: webDesign,
    //   description:
    //     "Flint Infotech delivered beyond our expectations. Their e-commerce web app not only streamlined our sales but also provided an unparalleled shopping experience for our customers. Highly recommended!",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Aishwarya Patel",
    //   company: "Tech Innovators Pvt. Ltd.",
    //   image: webDesign,
    //   description:
    //     "Choosing Flint Infotech for our static web app needs was the right decision. Their elegant designs and user-friendly interface have transformed our online image, leaving a lasting impression on our clients.",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Rajesh Kumar",
    //   company: "Global Solutions Enterprises",
    //   image: coding,
    //   description:
    //     "Flint Infotech's business web app revolutionized our internal processes. The customized solution enhanced our efficiency, and their commitment to our project was exemplary.",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Priya Sharma",
    //   company: "Eminent Financial Consultants",
    //   image: applcation,
    //   description:
    //     "Dynamic web apps by Flint Infotech brought our ideas to life. The real-time updates and interactive features have significantly boosted user engagement, making our platform more vibrant and appealing.",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Anand Gupta",
    //   company: "Stellar Pharmaceuticals Inc.",
    //   image: applcation,
    //   description:
    //     "Kudos to Flint Infotech for their exceptional cloud development expertise. Their solutions have elevated our digital infrastructure, providing scalability and security that align perfectly with our business goals.",
    // },
    {
      id: uuidv4(),
      title: "Mr. Vikrant Patil",
      company: "(आमदार-विधान परिषद महाराष्ट्र)",
      image: applcation,
      description:
        "When we first contacted Flint Infotech, we needed expert advice on the creation of the voter data analytical solution to achieve for establish connection with voter and build a messege system for communication . After a series of meeting , flint Infotech,consultants analyzed our workloads, documentation, and the existing infrastructure and provided us with a clear project roadmap.",
    },
    {
      id: uuidv4(),
      title: "Mr. Rafique Batliwala",
      company: "Al-Nuaim Group",
      image: applcation,
      description:
        "I would personally like to endorse the quality, expertise and professionalism of all the people that work at Flint Infotech. I can highly recommend this company which has at all times in the development cycle of our project expectation has met.",
    },
    {
      id: uuidv4(),
      title: "Mr. Pratik Chachad",
      company: "श्री शिवसह्याद्री संस्था महाराष्ट्र",
      image: applcation,
      description:
        "Very patient and polite staff. Ready to rework on any small thing till you get what you desire. It was a nice experience to work with them during our website development. Best wishes from my side",
    },
    {
      id: uuidv4(),
      title: "Mr. Bramhanand Patil", 
      company: "Sais Sanstha",
      image: applcation,
      description:
        "The team showed a strong understanding of our needs and goals from the outset. They took the time to listen to our requirements and thus providing us the best possible tailored solution.",
    },
    {
      id: uuidv4(),
      title: "Mr. Narsu Patil",
      company: "E. B. GADKARI HOMOEOPATHIC",
      image: applcation,
      description:
        "The design of the website effectively reflects the professional and authoritative image of our institute. We appreciate efforts, collaboration, professionalism, and support the team has shown to us.",
    },
    {
      id: uuidv4(),
      title: "Ms. Geeta Maheshwari",
      company: "Efficacious India Limited",
      image: applcation,
      description:
        "Flint Infotech has been providing Mobile and Web application development services and server managed services has delivered as per requirements and better than the expectations of E-SMART. We truly enjoy working with Flint's committed team.",
    },
  ];

  return (
    <div className="mt-10" id="reviews">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold">
        What they are talking about{" "}
        <span className="italic font-bold">Flint</span>
      </p>
      <div className="px-0 sm:px-4 mt-10 rounded-xl mx-5 sm:mx-20">
        <Carousel
          responsive={responsive}
          infinite={true}
          className="p-2 sm:p-4"
        >
          {featureList.map((item) => (
            <div
              key={item.id}
              className="flex flex-col justify-between mx-4 rounded-xl shadow-md p-2 h-full bg-gradient-to-b from-emerald-50 to-fuchsia-200 border-[1px] border-slate-300"
            >
              <div className="font-notosans p-3 text-[15px]">{item.description}</div>
              {/* <div className="w-16 overflow-hidden inline-block">
                <div className=" h-5 w-5 mx-5 bg-gray-200 -rotate-45 transform origin-top-left"></div>
              </div> */}
              <div className=" text-black font-bold font-notosans flex items-center gap-7">
                <div>
                  <img src={feedback} className="w-16" />
                </div>
                <div>
                  <p>{item.title}</p>
                  <div className="group cursor-pointer relative inline-block">
                    <p className="overflow-hidden truncate w-60 text-sm">
                      {item.company}
                    </p>
                    <div className="opacity-0 w-full bg-black text-white text-center text-xs rounded-lg py-2 absolute z-10 group-hover:opacity-100 bottom-full -left-1/2 ml-14 px-3 pointer-events-none">
                    {item.company}
                      <svg
                        className="absolute text-black h-2 w-full left-0 top-full"
                        x="0px"
                        y="0px"
                        viewBox="0 0 255 255"
                      >
                        <polygon
                          className="fill-current"
                          points="0,0 127.5,127.5 255,0"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Testimonials;
